module.exports = __webpack_public_path__ + "static/media/device_phone.1e4991c3.svg";